/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Active_BackdropInputs */

const en_active_backdrop = /** @type {(inputs: Active_BackdropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active Backdrop`)
};

const es_active_backdrop = /** @type {(inputs: Active_BackdropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fondo activo`)
};

const fr_active_backdrop = /** @type {(inputs: Active_BackdropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toile de fond active`)
};

const de_active_backdrop = /** @type {(inputs: Active_BackdropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiver Hintergrund`)
};

const ja_active_backdrop = /** @type {(inputs: Active_BackdropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティブな背景`)
};

const zh_active_backdrop = /** @type {(inputs: Active_BackdropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前背景`)
};

const ar_active_backdrop = /** @type {(inputs: Active_BackdropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الخلفية النشطة`)
};

const id_active_backdrop = /** @type {(inputs: Active_BackdropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latar Belakang Aktif`)
};

const it_active_backdrop = /** @type {(inputs: Active_BackdropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sfondo Attivo`)
};

const ru_active_backdrop = /** @type {(inputs: Active_BackdropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текущий фон`)
};

const pt_active_backdrop = /** @type {(inputs: Active_BackdropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano de Fundo Ativo`)
};

const ko_active_backdrop = /** @type {(inputs: Active_BackdropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`활성화된 배경`)
};

/**
* | output |
* | --- |
* | "Active Backdrop" |
*
* @param {Active_BackdropInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const active_backdrop = /** @type {((inputs?: Active_BackdropInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Active_BackdropInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_active_backdrop(inputs)
	if (locale === "es") return es_active_backdrop(inputs)
	if (locale === "fr") return fr_active_backdrop(inputs)
	if (locale === "de") return de_active_backdrop(inputs)
	if (locale === "ja") return ja_active_backdrop(inputs)
	if (locale === "zh") return zh_active_backdrop(inputs)
	if (locale === "ar") return ar_active_backdrop(inputs)
	if (locale === "id") return id_active_backdrop(inputs)
	if (locale === "it") return it_active_backdrop(inputs)
	if (locale === "ru") return ru_active_backdrop(inputs)
	if (locale === "pt") return pt_active_backdrop(inputs)
	return ko_active_backdrop(inputs)
});